import axios from "axios";
import actions from "./actions";
import actionsAlert from "../alert/actions";
import { API_HOST, API } from "@configs/api";
import {
  isAdmin,
  isManager,
  setToken,
  setUserRole,
  getUser,
  removeToken,
  getUserId,
  getLoginStatus,
  isClient,
  isCandidate,
  isConsultant,
  setRefreshToken,
} from "@services/authentificationServices";
import { applyMissionPostulation } from "@store/candidature/actionCreactor";
import jwtDecode from "jwt-decode";

const {
  userTypeToggle,
  loginSuccess,
  forgetPasswordAction,
  resetPasswordAction,
  sectors,
  jobsTypes,
  professions,
  locations,
  nationalities,
  workingPermission,
  agencesList,
  isAccountDisabled,
  reactivateAccount,
} = actions;
const { alert } = actionsAlert;

const setUserType = (identity) => {
  console.log("identity: ", identity);
  return (dispatch) => {
    if (identity === 0) {
      dispatch(userTypeToggle("candidate"));
    } else {
      dispatch(userTypeToggle("agency"));
    }
  };
};

const register = (data, dataLogin, missionId, title) => {
  const URL = API_HOST + API.auth.register;
  // Retrieve the email value from the FormData object
  var email = data.get("email");
  // save the email value
  localStorage.setItem("_mail_to_save", email);

  return async (dispatch) => {
    axios.post(URL, data).then(
      (res) => {
        if (res.data.code === 200) {
          if (missionId) {
            dispatch(loginPostulation(dataLogin, missionId, title));
          } else {
            dispatch(
              alert({
                msg: "success_register_user",
                redirectLink: "return_login_page",
                type: "success",
              })
            );
          }
          localStorage.removeItem("cv");
          localStorage.removeItem("jobsList");
          localStorage.removeItem("birthdate");
        } else if (res.data.code === 400) {
          dispatch(alert({ msg: "email_exist", type: "error" }));
        }
      },
      (err) => {
        dispatch(alert({ msg: "error_register", type: "error" }));
      }
    );
  };
};

const checkExistMail = (data, setErrorEmailExist) => {
  const URL = API_HOST + API.auth.checkExistMail;
  return async (dispatch) => {
    axios.post(URL, data).then(
      (res) => {
        setErrorEmailExist(false);
      },
      (err) => {
        setErrorEmailExist(true);
      }
    );
  };
};

const reactivatingAccount = (id) => {
  const URL = API_HOST + API.auth.reactivate + id;
  return async (dispatch) => {
    axios
      .get(URL)
      .then((res) => {
        dispatch(reactivateAccount(res.data));
      })
      .catch((err) => console.log(err));
  };
};

const login = (data, history, identity) => {
  try {
    const URL = API_HOST + API.auth.login;
    return async (dispatch) => {
      axios.post(URL, data).then(
        (res) => {
          if (res.status === 200) {
            setToken(res.data.token);
            setRefreshToken(res.data.refresh_token);
            setUserRole(getUser(res.data.token).roles[0]);
            dispatch(loginSuccess(res.data.token));
            if (identity === 0 && isCandidate()) {
              if (getUser().verified) {
                if (getLoginStatus() === "204") {
                  dispatch(
                    isAccountDisabled({
                      type: "personal",
                      title: "reactivate_account",
                      message: "subtitle_reactivate_account",
                    })
                  );
                  dispatch(reactivatingAccount(getUserId()));
                  setUserRole(getUser(res.data.token).roles[0]);
                } else if (getLoginStatus() === "409") {
                  removeToken();
                  dispatch(
                    isAccountDisabled({
                      type: "recruiter",
                      title: "descativate_account",
                      message: "subtitle_desactivate_account",
                    })
                  );
                } else {
                  history.push("/tableau-de-bord");
                }
              } else {
                dispatch(
                  alert({
                    msg: "not_verified_account",
                    type: "warning",
                    actionButtons: [
                      {
                        name: "verif_request",
                        action: () => {
                          dispatch(
                            emailVerification(
                              jwtDecode(res.data.token).username
                            )
                          );
                        },
                      },
                    ],
                  })
                );
                removeToken();
              }
            } else if (identity === 0 && !isCandidate()) {
              dispatch(alert({ msg: "verified_account", type: "warning" }));
              removeToken();
            } else if (
              (identity === 1 && isAdmin()) ||
              (identity === 1 && isConsultant())
            ) {
              history.push("/tableau-bord-agence");
            } else if (
              (identity === 1 && isManager()) ||
              (identity === 1 && isClient())
            ) {
              if (getUser().verified) {
                history.push("/creer-une-annonce");
              } else {
                dispatch(
                  alert({
                    title: "agency_not_verified_account_title",
                    msg: "agency_not_verified_account_subtitle",
                    type: "warning",
                  })
                );
                removeToken();
              }
            } else if (
              identity === 1 &&
              !isClient() &&
              !isConsultant() &&
              !isAdmin() &&
              !isManager()
            ) {
              dispatch(alert({ msg: "verified_account", type: "warning" }));
              removeToken();
            }
          } else {
            dispatch(alert({ msg: "invalid_dredential", type: "error" }));
            removeToken();
          }
        },
        (err) => {
          dispatch(alert({ msg: "invalid_dredential", type: "error" }));
        }
      );
    };
  } catch (err) {
    console.log("err", err);
  }
};

const checkEmailState = (data, setModalOldCandidate, setLink) => {
  const URL = API_HOST + API.auth.checkEmailState;
  return async (dispatch) => {
    axios.post(URL, data).then(
      (res) => {
        setLink(res.data.url);
        setModalOldCandidate(true);
      },
      (err) => {
        console.log("err", err);
      }
    );
  };
};

const loginWithSocial = (data, history, identity) => {
  const URL = API_HOST + API.auth.socialLogin;
  return async (dispatch) => {
    axios.post(URL, data).then(
      (res) => {
        if (res.status === 200) {
          setToken(res.data.token);
          setRefreshToken(res.data.refresh_token);
          setUserRole(getUser(res.data.token).roles[0]);
          dispatch(loginSuccess(res.data.token));
          if (getUser().verified) {
            if (identity === 0 && isCandidate()) {
              if (getLoginStatus() === "204") {
                dispatch(
                  isAccountDisabled({
                    type: "personal",
                    title: "reactivate_account",
                    message: "subtitle_reactivate_account",
                  })
                );
                dispatch(reactivatingAccount(getUserId()));
                setUserRole(getUser(res.data.token).roles[0]);
              } else if (getLoginStatus() === "409") {
                removeToken();
                dispatch(
                  isAccountDisabled({
                    type: "recruiter",
                    title: "descativate_account",
                    message: "subtitle_desactivate_account",
                  })
                );
              } else {
                history.push("/tableau-de-bord");
              }
            } else if (identity === 0 && !isCandidate()) {
              dispatch(alert({ msg: "verified_account", type: "warning" }));
              removeToken();
            } else if (
              (identity === 1 && isAdmin()) ||
              (identity === 1 && isConsultant())
            ) {
              history.push("/tableau-bord-agence");
            } else if (
              (identity === 1 && isManager()) ||
              (identity === 1 && isClient())
            ) {
              history.push("/creer-une-annonce");
            } else if (
              identity === 1 &&
              !isClient() &&
              !isConsultant() &&
              !isAdmin() &&
              !isManager()
            ) {
              dispatch(alert({ msg: "verified_account", type: "warning" }));
              removeToken();
            }
          } else {
            dispatch(
              alert({
                msg: "not_verified_account",
                type: "warning",
                actionButtons: [
                  {
                    name: "verif_request",
                    action: () => {
                      dispatch(
                        emailVerification(jwtDecode(res.data.token).username)
                      );
                    },
                  },
                ],
              })
            );
            removeToken();
          }
        } else {
          dispatch(alert({ msg: "invalid_dredential", type: "error" }));
          removeToken();
        }
      },
      (err) => {
        if (
          err.response.data.includes(
            "Utilisateur non trouvé pour l'adresse e-mail"
          )
        ) {
          dispatch(
            alert({
              title: "unsaved_mail_title",
              msg: "unsaved_mail_subtitle",
              type: "error",
            })
          );
        }
      }
    );
  };
};

const LinkedInLogin = (access_token, history, identity) => {
  const URL = API_HOST + API.auth.loginLinkedIn;
  return async (dispatch) => {
    axios.get(URL, { params: { access_token } }).then((res) => {
      dispatch(loginWithSocial({ email: res.data.email }, history, identity));
    });
  };
};

const forgetPassword = (local, data) => {
  const URL = API_HOST + API.auth.forgetPassword;
  return async (dispatch) => {
    axios.post(URL, data, { params: local }).then(
      (res) => {
        if (res.data.code === 200) {
          dispatch(
            alert({ msg: "success_send_mail_reset_pwd", type: "success" })
          );
          dispatch(forgetPasswordAction(res.data));
        }
      },
      (error) => {
        if (error.response.status === 404) {
          dispatch(alert({ msg: "email_not_exist", type: "error" }));
        }
      }
    );
  };
};

const resetPassword = (data, token) => {
  const URL = API_HOST + API.auth.resetPassword + `/${token}`;
  return async (dispatch) => {
    axios.post(URL, data).then((res) => {
      if (
        res.status === 200 &&
        res.data.success === "password has been updated"
      ) {
        dispatch(
          alert({
            msg: "reset_password_saccess_title",
            type: "success",
            redirectLink: "return",
          })
        );
        dispatch(resetPasswordAction(res.data));
      } else {
        dispatch(alert({ msg: "echec_update_pwd", type: "error" }));
      }
    });
  };
};

const getSectors = (dataLocal) => {
  const URL = API_HOST + API.auth.sectors;
  let data = [];
  return async (dispatch) => {
    axios.post(URL, {}, { params: dataLocal }).then((res) => {
      res.data.map((el) => {
        data.push({
          value: el.id,
          label: el.name,
        });
      });
      dispatch(sectors(data));
    });
  };
};

const getProfessions = (dataLocal) => {
  const URL = API_HOST + API.auth.professions;
  let data = [];
  return async (dispatch) => {
    axios.post(URL, {}, { params: dataLocal }).then((res) => {
      res.data.map((el) => {
        data.push({
          value: el.id,
          label: el.name,
        });
      });
      dispatch(professions(data));
    });
  };
};

const getJobsTypes = (dataLocal) => {
  const URL = API_HOST + API.auth.jobtypes;
  let data = [];
  return async (dispatch) => {
    axios.get(URL, { params: dataLocal }).then((res) => {
      res.data.map((el) => {
        data.push({
          value: el.id,
          label: el.name,
          checked: false,
        });
      });
      dispatch(jobsTypes(data));
    });
  };
};

const getNationalities = (dataLocal) => {
  const URL = API_HOST + API.auth.nationalities;
  let data = [];
  return async (dispatch) => {
    axios.get(URL, { params: dataLocal }).then((res) => {
      res.data.map((el) => {
        data.push({
          value: el.id,
          label: el.name,
          code: el.code,
        });
      });
      dispatch(nationalities(data));
    });
  };
};

const getLocations = (dataLocal) => {
  const URL = API_HOST + API.auth.locations;
  return async (dispatch) => {
    axios.get(URL, { params: dataLocal }).then((res) => {
      dispatch(locations(res.data));
    });
  };
};

const getLocationsProfile = () => {
  const URL = API_HOST + API.auth.locations;
  return async (dispatch) => {
    axios.get(URL).then((res) => {
      dispatch(locations(res.data));
    });
  };
};

const getWorkingPermissions = (dataLocal) => {
  const URL = API_HOST + API.auth.workingpermissions;
  let data = [];
  return async (dispatch) => {
    axios.get(URL, { params: dataLocal }).then((res) => {
      res.data.map((el) => {
        data.push({
          value: el.id,
          label: el.description,
          name: el.name
        });
      });
      dispatch(workingPermission(data));
    });
  };
};

const getListAgences = (data, page) => {
  const URL = API_HOST + API.auth.listAgences;
  return async (dispatch) => {
    axios.post(URL, data, { params: page }).then((res) => {
      dispatch(agencesList(res.data));
    });
  };
};

const logOut = () => {
  removeToken();
  window.location.assign("/");
};

const registerAgency = (data) => {
  const URL = API_HOST + API.auth.registerAgency;
  return async (dispatch) => {
    axios.post(URL, data).then(
      (res) => {
        if (res.data.code === 200) {
          dispatch(
            alert({
              msg: "success_register_user",
              redirectLink: "return_login_page",
              type: "success",
            })
          );
        } else if (res.data.code === 400) {
          dispatch(alert({ msg: "email_exist", type: "error" }));
        }
      },
      (err) => {
        dispatch(alert({ msg: "error_register", type: "error" }));
      }
    );
  };
};

const loginPostulation = (data, idMission, title) => {
  try {
    const URL = API_HOST + API.auth.login;
    return async (dispatch) => {
      axios.post(URL, data).then(
        (res) => {
          if (res.status === 200) {
            setToken(res.data.token);
            setRefreshToken(res.data.refresh_token);
            setUserRole(getUser(res.data.token).roles[0]);
            dispatch(loginSuccess(res.data.token));
            dispatch(applyMissionPostulation({ missionId: idMission }, title));
          }
        },
        (err) => {
          dispatch(alert({ msg: "invalid_dredential", type: "error" }));
        }
      );
    };
  } catch (err) {
    console.log("err", err);
  }
};

const emailVerification = (data) => {
  try {
    const URL = API_HOST + API.auth.emailVerification;
    return async (dispatch) => {
      axios.post(URL, { email: data }).then(
        (res) => {
          if (res.status === 200) {
            dispatch(alert({ msg: "verified_account", type: "success" }));
          }
        },
        (err) => {
          dispatch(alert({ msg: "not_verified_account", type: "error" }));
        }
      );
    };
  } catch (err) {
    console.log("err", err);
  }
};
export {
  loginPostulation,
  reactivatingAccount,
  setUserType,
  register,
  checkExistMail,
  login,
  checkEmailState,
  loginWithSocial,
  getLocationsProfile,
  forgetPassword,
  resetPassword,
  getSectors,
  getProfessions,
  getJobsTypes,
  getNationalities,
  getLocations,
  getWorkingPermissions,
  getListAgences,
  logOut,
  registerAgency,
  LinkedInLogin,
  emailVerification,
};
